<template>
  <div class="tournament-list">
    <div class="main-header">
      <div class="container">
        <div class="header-wrapper">
          <div class="header-left">
            <h1>Clubs</h1>
            <h4 class="subtitle">grupos e comunidades para matchmaking entre membros</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="clubs-listing">
        <router-link
          :to="{ name: 'ClubSingle', params: { id: club.slug }}"
          v-for="club in clubs"
          :key="club.id"
          class="club-card"
        >
          <figure class="club-badge">
            <b-img :src="club.badge.url"/>
          </figure>
          <div class="club-content">
            <h4 v-html="club.name"></h4>
            <p>{{club.club_users_count}} membros</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import BlogpostCard from '@/components/BlogpostCard'
import Header from "@/components/Header";
export default {
  name: "ClubList",
  metaInfo: {
    title: "Clubs"
  },
  data() {
    return {
      clubs: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("clubs.json")
        .then(response => (this.clubs = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header
  }
  // BlogpostCard,
};
</script>

<style lang="sass">
body.clubs-page
  // background: #f1f1f1

  .clubs-listing
    display: flex
    flex-wrap: wrap
    // justify-content: space-between
    margin-top: 20px
    @media(min-width: 600px)
      margin: 0 10%
    
    .club-card
      display: flex
      align-items: center
      width: 100%
      background: rgba(255, 255, 255, .1)
      padding: 10px
      margin: 10px
      border-radius: 4px

      &:hover
        text-decoration: none
        background: #cfcfcf
        transform: scale(1.02)
        transition: all .3s ease
        .club-content
          color: #111
        
    
      .club-badge
        width: 64px
        height: 64px
        margin-bottom: 0
        img
          width: 100%
          height: auto
            
      .club-content
        margin-left: 10px
        color: white
        transition: all .2s
        h4
          margin-bottom: 0
        p
          margin: 0
          font-size: 12px
      
</style>
